import { useEditSceneModalStateContext } from './EditSceneModalStateContext';

export default function useSlotCount() {
  const {
    state: { slotCount },
  } = useEditSceneModalStateContext();

  return {
    slotCount,
  };
}
